define('../app/fukit/behavior/toggle.state.editing.on.press.behavior',['require','exports','module','marionette','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var Mn = require('marionette'),
      Radio = require('backbone.radio');

  var ToggleStateEditingOnPressBehavior = Mn.Behavior.extend({
    onPress: function() {
      var state = Radio.channel('AppKit.controllerService').request('state');

      if (state) {
        state.set('editing', !state.get('editing'));
      }
    },
  });

  module.exports = ToggleStateEditingOnPressBehavior;
});

